import { render } from "./VotingAnalytics.vue?vue&type=template&id=23e354b9&scoped=true"
import script from "./VotingAnalytics.vue?vue&type=script&lang=js"
export * from "./VotingAnalytics.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=23e354b9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e354b9"]])

export default __exports__